// mutations
export default {
  setUnreadCount(state, count) {
    console.log('setUnreadCount');
    state.unreadCount = count;
  },

  setUnreadIds(state, ids) {
    console.log('setUnreadIds');
    state.unreadIds = ids;
  },
};
